////////////////////////// AUTOGENERATED WARNING ////////////////////////////////
//
// THIS FILE IS AUTOGENERATED
// DO NOT EDIT MANUALLY
//
// SOURCE: Fill the 'Language' column in the 'GenerateLanguages.csv'
//
///////////////////////// AUTOGENERATED WARNING ////////////////////////////////

export enum LanguageId {
	En = 1,
	Hu = 2,
}
